import React from 'react';
import type { QuoteStatus } from '../../types/quote';
const tones: Record<QuoteStatus, string> = {
  Kladde: 'bg-[#eef0f2] text-ink-soft border-[#dfe3e7]',
  Sendt: 'bg-[#fbf3e0] text-status-warn border-[#f0e2bf]',
  Accepteret: 'bg-[#eaf1ea] text-status-ok border-[#d3e3d5]',
  Afvist: 'bg-danger/10 text-danger border-danger/25',
  Udløbet: 'bg-canvas text-ink-muted border-line'
};
export function QuoteStatusBadge({
  status,
  className = ''
}: {
  status: QuoteStatus;
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium ${tones[status]} ${className}`} data-id="element-294" data-mp="1dp8gno1nn18e">
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden="true" data-id="element-295" data-mp="1mqpros07gcq8" />
      {status}
    </span>;
}